import * as React from 'react';
import * as ReactDOM from 'react-dom/client';

import AppProvider from '@/providers/app-provider';
import env from '@/config/env';
import { captureDeepLink } from '@/lib/deep-link';
import '@/lib/i18n';
import '@/styles.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('No root element found.');
}

// Snapshot the URL the user loaded on before Keycloak's `login-required`
// redirect (fired from an effect after render) round-trips back to the bare
// origin and discards the path + query. Restored from the `/` route post-auth.
captureDeepLink();

const root = ReactDOM.createRoot(rootElement);

const app = <AppProvider />;

root.render(
  env.isProduction() ? app : <React.StrictMode>{app}</React.StrictMode>,
);
